/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import routes from '../../common/constants/RouteConstants';
import { getPasswordFormatValidationStatus } from '../../common/util/validatorUtil';
import { forgotPasswordSubmit } from '../../store/routines';
import { parseParams } from '../../common/util/Parsers';
import PasswordSetup from './PasswordSetup';
import InputValidationMessage from '../../components/InputMessageContainers/InputValidationMessage';

function ResetPasswordForm() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [passwordValidationStatus, setPasswordValidationStatus] = useState(
    getPasswordFormatValidationStatus('')
  );
  const [user, setUser] = useState(getPasswordFormatValidationStatus(''));

  const isSuccess = useSelector((state) => state.auth.isSuccess);
  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const isError = useSelector((state) => state.auth.isError);
  const isLoading = useSelector((state) => state.auth.isLoading);

  useEffect(() => {
    const { username } = parseParams(location.search);
    if (username) {
      setUser(username);
    } else {
      history.push(routes.loginManagement.login);
    }
  }, [history, location.search]);

  useEffect(() => {
    if (isSuccess && !isLoading) {
      history.push(routes.loginManagement.login);
    }
  }, [isSuccess, isLoading, history]);

  const onResetPasswordFinish = (values) => {
    const { verificationCode, password } = values;
    dispatch(
      forgotPasswordSubmit({ username: user, code: verificationCode, password })
    );
  };

  const formValidator = (hangedValues) => {
    if ('password' in hangedValues) {
      setPasswordValidationStatus(
        getPasswordFormatValidationStatus(hangedValues.password)
      );
    }
  };
  return (
    <>
      <div className="login-input-wrapper">
        <div className="title smaller">Reset your password</div>
        <div className="subtitle">
          Choose a new password. Make sure it&apos;s a strong one!
        </div>
        <Form
          name="login_step_1"
          className="login-form"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onResetPasswordFinish}
          onValuesChange={formValidator}
        >
          {isError && (
            <div className="login-error-bar">
              <i className="icon core-icon core-alert-outlined" />{' '}
              {errorMessage}
            </div>
          )}
          <Form.Item
            className="login-field  no-margin-bottom"
            label="Verification Code"
            name="verificationCode"
            rules={[
              {
                required: true,
                message: (
                  <InputValidationMessage message="Please enter your verification code" />
                ),
              },
            ]}
          >
            <Input className="login-field " maxLength="6" />
            {/* <div className="otp-border">
              <div className="cell"> </div>
              <div className="cell"> </div>
              <div className="cell"> </div>
              <div className="cell"> </div>
              <div className="cell"> </div>
              <div className="cell"> </div>
              <div className="cell"> </div>
            </div> */}
          </Form.Item>

          <PasswordSetup validationStatus={passwordValidationStatus} />

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button loginbtn"
              disabled={Object.values(passwordValidationStatus).some(
                (element) => element === false
              )}
            >
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="floating-login-footer">
        <div>
          Can’t find your code? Check your spam folder!{' '}
          <a
            tabIndex={0}
            role="button"
            onClick={() => history.push(routes.loginManagement.forgotPassword)}
            className="request-new-pw"
          >
            Resend Code
          </a>
        </div>
        <div>
          Remember your password?{' '}
          <a
            tabIndex={0}
            role="button"
            onClick={() => history.push(routes.loginManagement.login)}
            className="request-new-pw"
          >
            Back to Log in
          </a>
        </div>
      </div>
    </>
  );
}

export default ResetPasswordForm;
